import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import FormikSemanticInput from "../forms/formik/FormikSemanticInput.jsx";
import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import ConfirmationModal from "./ConfirmationModal.jsx";

import { hydrateCopyObjectWithEntity } from "../../state/reducers/locale/copyUtils.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ChallengeConfirmationModal extends PureComponent {
  static propTypes = {
    entity: PropTypes.object.isRequired,
    violationErrors: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "modals"
  };

  constructor(props) {
    super(props);

    this.state = this.setDefaultState();
  }

  setDefaultState = () => {
    return {
      showConfirmationModal: false,
      validatedData: {},
      initialValues: {
        challengeResponse: ""
      }
    };
  };

  // -- HANDLERS & ACTIONS -- //

  closeHandler = confirmed => {
    this.setState(this.setDefaultState(), this.props.onClose(confirmed));
  };

  onChallengeSubmit = (evt, data) => {
    const validatedData = {
      ...data,
      ["data-confirmed"]: "true"
    };

    this.setState({
      validatedData,
      showConfirmationModal: true
    });
  };

  validationSchema = () => {
    const { entity, copyKey, copy } = this.props;
    const id = entity.id;
    const atId = entity["@id"];

    const name = copy(`${copyKey}.challenge.challenge_response_label`);
    const messages = copy(`${copyKey}.challenge.challenge_response_validation`);

    return Yup.object().shape({
      challengeResponse: Schemas.oneOfPossibleValues(
        name,
        messages,
        [id, atId],
        true
      )
    });
  };

  // -- RENDER -- //

  renderChallengeModal = () => {
    const { entity, open, violationErrors, copyKey, copy } = this.props;

    const challengeCopy = hydrateCopyObjectWithEntity(
      copy(`${copyKey}.challenge`),
      entity
    );

    return (
      <Formik
        initialValues={this.state.initialValues} // required by semantic-ui react
        validationSchema={this.validationSchema()}
        onSubmit={this.onChallengeSubmit}
      >
        {formikProps => {
          return (
            <ConfirmationModal
              open={open}
              onClose={this.closeHandler}
              onConfirm={formikProps.handleSubmit}
              copy={challengeCopy}
            >
              <SegmentMessage
                info={true}
                title={challengeCopy.warning.title}
                message={challengeCopy.warning.message}
              />
              <Form className="ui form">
                <p>{challengeCopy.description}</p>
                <Field
                  name="challengeResponse"
                  placeholder={challengeCopy.challenge_response_placeholder}
                  label={challengeCopy.challenge_response_label}
                  required
                  apiErrors={violationErrors}
                  component={FormikSemanticInput}
                />
              </Form>
              <br />
            </ConfirmationModal>
          );
        }}
      </Formik>
    );
  };

  renderConfirmationModal = () => {
    const { entity, open, copyKey, copy } = this.props;

    const confirmationCopy = hydrateCopyObjectWithEntity(
      copy(`${copyKey}.confirmation`),
      entity
    );

    return (
      <ConfirmationModal
        open={open}
        onClose={this.closeHandler}
        copy={confirmationCopy}
      >
        <SegmentMessage
          negative={true}
          title={confirmationCopy.warning.title}
          message={confirmationCopy.warning.message}
        />
        <p>{confirmationCopy.description}</p>
      </ConfirmationModal>
    );
  };

  render() {
    const { open, entity } = this.props;

    if (!open || !entity) return null;

    if (!this.state.showConfirmationModal) {
      return this.renderChallengeModal();
    } else {
      return this.renderConfirmationModal();
    }
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ChallengeConfirmationModal);
